import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'public/environments/environment';
export enum Source {
  Meetings = 'Meetings',
  Messages = 'Messages',
  SignDocs = 'SignDocs'
}
export enum OTPTypes {
  MOM, MOMDoc, MsgDoc, SignDocs
}

@Injectable({ providedIn: 'root' })
export class PDFViewerService {

  constructor(private http: HttpClient) {
  }

  SaveAgindaDocumentSignature(data) { // Save Configration
    return this.http.post(`${environment.apiUrl}/MeetingAgendaItems/SaveAgindaDocumentSignature/`, data);
  }

  getDocDetails(data, source: Source): any {
    if (source == Source.Meetings) {
      return this.http.post(`${environment.apiUrl}/MeetingAgendaItems/GetAgindaDocumentDetails/`, data);
    }
    if (source == Source.Messages) {
      return this.http.post(`${environment.apiUrl}/messages/GetAttachmentDocumentSignetureDetails/`, data);
    }
    if (source == Source.SignDocs) {
      return this.http.post(`${environment.apiUrl}/DocumentsSignature/GetAttachmentDocumentSignetureDetails/`, data);
    }
  }

  RequestOneTimePassword(id, type: OTPTypes):any {
    if (type == OTPTypes.MOM) {
      return this.http.get(`${environment.apiUrl}/meetings/RequestFirstOneTimePassword/?meetingId=` + id);
    }
    if (type == OTPTypes.MOMDoc) {
      return this.http.get(`${environment.apiUrl}/MeetingAgendaItems/RequestAgindaDocumentFirstOneTimePassword?documentId=` + id);
    }
    if (type == OTPTypes.MsgDoc) {
      return this.http.get(`${environment.apiUrl}/messages/RequestMessageDocumentFirstOneTimePassword?documentId=` + id);
    }
    if (type == OTPTypes.SignDocs) {
      return this.http.get(`${environment.apiUrl}/DocumentsSignature/RequestDocumentSignatureFirstOneTimePassword?documentId=` + id);
    }
  }
  SubmitMySignature(obj, type: OTPTypes): any {
    if (type == OTPTypes.MOM) {
      return this.http.post(`${environment.apiUrl}/meetings/SubmitMySignature`, obj);
    }
    if (type == OTPTypes.MOMDoc) {
      return this.http.post(`${environment.apiUrl}/MeetingAgendaItems/SubmitMyAgindaDocumentSignature`, obj);
    }
    if (type == OTPTypes.MsgDoc) {
      return this.http.post(`${environment.apiUrl}/messages/SubmitMyMessageDocumentSignature`, obj);
    }
    if (type == OTPTypes.SignDocs) {
      return this.http.post(`${environment.apiUrl}/DocumentsSignature/SubmitMyDocumentSignature`, obj);
    }
  }
}
